import { cn } from "@/lib/utils";

export interface DocumentModeOption<M extends string> {
  id: M;
  title: string;
  desc: string;
}

export function DocumentModeCards<M extends string>({
  modes,
  selected,
  onPick,
  disabled,
}: {
  modes: DocumentModeOption<M>[];
  selected: M | null;
  onPick: (mode: M) => void;
  disabled?: boolean;
}) {
  return (
    <div className="grid grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-3">
      {modes.map((m) => {
        const active = selected === m.id;
        return (
          <button
            key={m.id}
            type="button"
            disabled={disabled}
            onClick={() => onPick(m.id)}
            className={cn(
              "rounded-[13px] p-4 text-left transition-colors disabled:opacity-60",
              active
                ? "border-[1.5px] border-primary bg-accent"
                : "border border-dashed border-border hover:bg-muted",
            )}
          >
            <div className={cn("text-[13px] font-bold", active && "text-primary")}>{m.title}</div>
            <div className="mt-[5px] text-[11.5px] leading-[1.5] text-muted-foreground">
              {m.desc}
            </div>
          </button>
        );
      })}
    </div>
  );
}
